import { render, staticRenderFns } from "./Account3Index.vue?vue&type=template&id=4b10c18e&scoped=true"
import script from "./Account3Index.vue?vue&type=script&lang=js"
export * from "./Account3Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b10c18e",
  null
  
)

export default component.exports